import { defineMessages } from 'react-intl-next';

export default defineMessages({
	betaTag: {
		id: 'rovo-chat.view-agent.beta-tag',
		defaultMessage: 'Beta',
		description: 'Tag to display for beta actions',
	},
} as const);
